import { faEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { MenuItems } from '../view-models/workoutEdit.viewModel';
import { clsx } from 'clsx';
import { Typography } from '@design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const WorkoutItemMenu = ({
  items,
  isCircuit,
  readonly,
}: {
  items: MenuItems;
  isCircuit: boolean;
  readonly?: boolean;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (ev: React.MouseEvent<HTMLDivElement>) => {
    ev.preventDefault();
    ev.stopPropagation();
    setAnchorEl(ev.currentTarget);
  };
  const handleClose = (ev: React.MouseEvent<HTMLLIElement>) => {
    ev.preventDefault();
    ev.stopPropagation();
    setAnchorEl(null);
  };
  return (
    <>
      <div onClick={handleClick} className="cursor-pointer">
        <FontAwesomeIcon
          icon={faEllipsis}
          className={clsx(
            isCircuit && 'text-black',
            !isCircuit && 'text-white',
          )}
        />
      </div>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {items.map(({ label, className, onClick, activeInReadonly }) => (
          <MenuItem
            onClick={(ev) => {
              ev.preventDefault();
              ev.stopPropagation();
              onClick();
              handleClose(ev);
            }}
            disabled={!activeInReadonly && readonly}
            key={label}
          >
            <Typography variant="body" size="large" className={clsx(className)}>
              {label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
